import simpleQuery from './simpleQuery';

export const getHomePageSettings = () => simpleQuery('settings');

export const findProviders = (providerKeys) => simpleQuery('providers', {
  filters: {
    key: providerKeys,
  },
});

export const findProviderDetails = (providerKeys) => simpleQuery('providerDetails', {
  filters: {
    key: providerKeys,
  },
});

export const findProviderTags = (providerKey) => simpleQuery('tags', {
  filters: {
    provider: providerKey,
  },
  columns: 'parent_tag',
});

export const findProducts = (productKeys) => simpleQuery('products', {
  filters: {
    key: productKeys,
    isEnded: false,
  },
});

export const findProductDetails = (productKeys) => simpleQuery('productDetails', {
  filters: {
    key: productKeys,
  },
});

export const briefSearchProducts = ({
  provider,
  keys,
  searchable,
  tags,
  orderBy,
  reverse,
  page,
}) => {
  const otherProps = {
    filters: {
      ...(provider ? { provider } : {}),
      ...(keys ? { key: keys } : {}),
      ...(tags && tags.length > 0 ? { tags } : {}),
      isEnded: false,
    },
    ...(searchable ? { searchable } : {}),
    ...(orderBy ? { orderBy } : {}),
    ...(reverse ? { reverse } : {}),
    ...(page ? { page } : {}),
  };

  if (tags && tags.length > 0) {
    return simpleQuery('tagProducts', {
      command: 'queryProductsWithTags',
      ...(otherProps),
    });
  }
  return simpleQuery('products', otherProps);
};

export const briefSearchProviders = ({ searchable }) => simpleQuery('providers', { searchable });

export const findProductStock = (productKey) => simpleQuery('productStock', {
  filters: {
    product: productKey,
  },
});

export default {};
